import AppShell from "@/components/AppShell/AppShell"
import DeckBrowser from "@/components/DeckBrowser/DeckBrowser"

/**
 * The deck on its own route.
 *
 * Pure static content from `content/cards` and `content/families` — no Firestore
 * read at all, so it works for a facilitator with no session open and cannot fail
 * to load.
 *
 * No `onClose`: the nav is the way out here, and a close button would have
 * nowhere to go back to.
 */
export default function DeckPage() {
  return (
    <AppShell>
      <DeckBrowser />
    </AppShell>
  )
}
